import { graphql } from "gql";

const MESSAGE_THREAD_FILES_MODAL_QUERY = graphql(`
  query MessageThreadFilesModal($id: ID!) {
    messageThread(id: $id) {
      id
      fileList {
        ...FileGallery
      }
      meRemovedUser {
        ...RemovedUser
      }
    }
  }
`);

export default MESSAGE_THREAD_FILES_MODAL_QUERY;
